import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Auth } from 'src/providers/auth/auth';
import { Me } from 'src/providers/me/me';

@Injectable()
export class AccountTypeGuard implements CanActivate {

  constructor (
    private auth: Auth,
    private me: Me,
    private navCtrl: CustomNavController
  ) {}

  async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    if (!this.auth.isAuthenticated()) {
      return true;
    }
    const accType = await this.me.getAccType();
    if (accType === 'employer') {
      this.navCtrl.navigateRoot('employer-dashboard/employer-dashboard');
      return false;
    }
    return true;
  }
}
